var React = require('react');

function ArrowAltToLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 424V88a23.94 23.94 0 0 1 24-24h16a23.94 23.94 0 0 1 24 24v336a23.94 23.94 0 0 1-24 24H24a23.94 23.94 0 0 1-24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M448 215.9v80a23.94 23.94 0 0 1-24 24H288v87.8c0 17.8-21.51 26.7-34.11 14.1L101.63 269.6a19.36 19.36 0 0 1 0-27.3L253.86 90.1c12.6-12.6 34.14-3.7 34.14 14.1v87.7h136a23.94 23.94 0 0 1 24 24z","className":"fa-primary","key":2})]);
}

ArrowAltToLeft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowAltToLeft;

ArrowAltToLeft.default = ArrowAltToLeft;
